<div class="p-6 bg-gray-50 min-h-screen">
  <header class="car-page__header pb-4">
    <h1 class="car-page__title">
      <span class="car-page__title-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
        </svg>
      </span>
      Catégorie
    </h1>
    <p class="car-page__subtitle">Gérer les catégories et ses détails</p>
  </header>

  <div class="grid grid-cols-1 lg:grid-cols-7 gap-8">
    <div class="lg:col-span-3 bg-white p-6 rounded-2xl shadow-sm border border-gray-200 h-fit">
      <h2 class="text-lg font-semibold mb-4 text-gray-800">Liste</h2>
      <app-show-tree-doc [param_code]="param_code" [File_Type]="'collaborateur'" [typeTrs]="'2'"></app-show-tree-doc>
    </div>

    <!-- ══ RIGHT PANEL — Détails catégories ══ -->
    <div class="lg:col-span-4">
      <section class="car-panel">
        <div class="car-panel__header">
          <div class="car-panel__header-left">
            <span class="car-panel__icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
              </svg>
            </span>
            Détails catégories
          </div>
          <div class="car-panel__header-actions">
            <button type="button" (click)="afficher()" class="car-btn car-btn--primary car-btn--sm">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              Afficher
            </button>
          </div>
        </div>

        <div class="car-panel__body">
          <form #f="ngForm">

            <!-- Catégorie search + toggles + image row -->
            <div class="grp-form-strip">

              <!-- Autocomplete input -->
              <div class="car-field car-field--grow">
                <label class="car-label">Catégorie</label>
                <input class="car-input" name="categorie_Model" [matAutocomplete]="categorieModel"
                  (input)="oncategorieModelValuechange($event)" #categorie_Model="ngModel"
                  [(ngModel)]="categorieSelected" [disabled]="disabled" placeholder="Rechercher une catégorie…" />
                <mat-autocomplete #categorieModel="matAutocomplete" [displayWith]="setTextInput"
                  (optionSelected)="categorieModelSelected($event)">
                  <mat-option *ngFor="let option of categories" [value]="option">
                    {{ option.categorie_Text | textPipe : 'capitalize' }}
                  </mat-option>
                </mat-autocomplete>
              </div>

              <!-- Image upload + delete (shown when item selected) -->
              <ng-container *ngIf="lastItemSelected">

                <!-- Toggle (1) — Afficher dans le menu -->
                <div class="cat-toggle-pill">
                  <label class="car-toggle car-toggle--sm">
                    <input type="checkbox" [ngModel]="Statuts == 1" [name]="'statuts_' + lastItemSelected"
                      (change)="onBlurStatuts(Statuts == 1 ? 0 : 1)" />
                    <span class="car-toggle__track"></span>
                  </label>
                  <span class="cat-toggle-pill__label">Menu</span>
                </div>

                <!-- Image thumbnail -->
                <div class="grp-img-upload">
                  <div class="grp-img-upload__preview" (click)="importer('input_280_580' + lastItemSelected)">
                    <img [id]="'280_580' + lastItemSelected"
                      [src]="(useDataBaseToSaveImage == 1 ? '' : base_url + 'images/') + mainCat.ecArtCat[0].categorie_Image"
                      onerror="this.src='assets/imageError.png'" />
                    <div class="grp-img-upload__overlay">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                        <circle cx="12" cy="13" r="4" />
                      </svg>
                    </div>
                  </div>
                  <input [id]="'input_280_580' + lastItemSelected" type="file" style="display:none"
                    (change)="onChangeImagefile($event, lastItemSelected, '280', '580')" />
                </div>

                <!-- Toggle (2) — Footer -->
                <div class="cat-toggle-pill">
                  <label class="car-toggle car-toggle--sm">
                    <input type="checkbox" [ngModel]="footerStatuts == 1" [name]="'footer_' + lastItemSelected"
                      (change)="onBlurMainCat(footerStatuts == 1 ? 0 : 1)" />
                    <span class="car-toggle__track"></span>
                  </label>
                  <span class="cat-toggle-pill__label">Footer</span>
                </div>

                <!-- Delete image button -->
                <button type="button" class="car-btn car-btn--danger car-btn--sm" [disabled]="!enregistrementTerminer"
                  (click)="supprimerImage(mainCat.ecArtCat[0])">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="3 6 5 6 21 6" />
                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                  </svg>
                  Supprimer image
                </button>

              </ng-container>
            </div>

            <!-- Description textarea (shown when item selected) -->
            <div class="car-field" *ngIf="lastItemSelected">
              <label class="car-label">Description</label>
              <textarea class="car-textarea" [(ngModel)]="setCategorie_Description" name="Categorie_Description"
                (blur)="SaveDescription()" placeholder="Description de la catégorie…" rows="4">
          </textarea>
            </div>

            <!-- Legend -->
            <div class="cat-legend" *ngIf="lastItemSelected">
              <span class="cat-legend__item">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                Menu : afficher la catégorie dans le menu
              </span>
              <span class="cat-legend__item">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                Footer : afficher la catégorie dans le pied de page
              </span>
            </div>

          </form>

          <!-- Categories table -->
          <div class="car-table-wrap">
            <table class="car-table">
              <thead>
                <tr>
                  <th style="width:70px">Code</th>
                  <th>Texte</th>
                  <th style="width:70px">Ordre</th>
                  <th style="width:60px" class="center">Active</th>
                  <th style="width:54px" class="center">Image</th>
                  <th style="width:60px" class="center">Footer</th>
                  <th style="width:54px" class="center">Suppr.</th>
                </tr>
              </thead>
              <tbody style="max-height: 400px;">
                <tr *ngFor="let element of dataSource.data ?? dataSource" (click)="selectRow($event, element)"
                  [class.selected]="element === selectedRow">

                  <td class="code">{{ element.categorie_Code }}</td>
                  <td class="bold">{{ element.categorie_Text | textPipe : 'capitalize' }}</td>

                  <!-- Ordre inline input -->
                  <td>
                    <input class="car-input car-input--ghost car-input--order" type="number"
                      (blur)="onBlur(element, false)" [(ngModel)]="element.categorie_Order"
                      [name]="'categorieText2' + element.categorie_Code" />
                  </td>

                  <!-- Active toggle -->
                  <td class="center">
                    <label class="car-toggle car-toggle--sm">
                      <input type="checkbox" [name]="'categorieActive' + element.categorie_Code"
                        [ngModel]="element.categorie_Statut == 1" (change)="onBlur(element, true)" />
                      <span class="car-toggle__track"></span>
                    </label>
                  </td>

                  <!-- Image upload cell -->
                  <td class="center">
                    <div class="cat-cell-img"
                      (click)="importer('input_280_580' + element.categorie_Code); $event.stopPropagation()">
                      <img [id]="'280_580' + element.categorie_Code"
                        [src]="(useDataBaseToSaveImage == 1 ? '' : base_url + 'images/') + element.categorie_Image"
                        onerror="this.src='assets/imageError.png'" />
                      <input [id]="'input_280_580' + element.categorie_Code" type="file" style="display:none"
                        (change)="onChangeImagefile($event, element.categorie_Code, '280', '580')" />
                    </div>
                  </td>

                  <!-- Footer toggle -->
                  <td class="center">
                    <label class="car-toggle car-toggle--sm">
                      <input type="checkbox" [name]="'categorieFooter' + element.categorie_Code"
                        [ngModel]="element.categorie_StatutFooter == 1"
                        (change)="onBlurFooter(element, element.categorie_StatutFooter == 1 ? 0 : 1)" />
                      <span class="car-toggle__track"></span>
                    </label>
                  </td>

                  <!-- Delete image -->
                  <td class="center">
                    <button type="button" class="grp-icon-btn grp-icon-btn--rose" [disabled]="!enregistrementTerminer"
                      (click)="supprimerImage(element); $event.stopPropagation()" title="Supprimer image">
                      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <polyline points="3 6 5 6 21 6" />
                        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                      </svg>
                    </button>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section>
    </div>
  </div>
</div>